import { Types } from '~/graphql';

export const getRandomUUID = (): Types.UUID => {
    if (typeof window === 'undefined') {
        const uuid = global.crypto.randomUUID() as Types.UUID;
        return uuid;
    } else {
        const uuid = window.crypto.randomUUID() as Types.UUID;
        return uuid;
    }
};
